import { render, staticRenderFns } from "./Messenger.vue?vue&type=template&id=784cdff9&"
import script from "./Messenger.ts?vue&type=script&lang=ts&"
export * from "./Messenger.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports